import React from "react";
import "../MissionVision.css";

import { FaBullseye, FaEye } from "react-icons/fa";

const MissionVision = () => {
  return (
    <section className="mission-vision">

      <div className="company-container">

        <span className="section-tag">
          MISSION & VISION
        </span>

        <h2>
          Driven by Purpose,
          <span> Inspired by Innovation</span>
        </h2>

        <p className="mv-intro">
          Our mission and vision define who we are, guide every decision we
          make, and inspire us to build innovative technology solutions that
          create long-term value for businesses across industries.
        </p>

        <div className="mv-grid">

          {/* Mission */}

          <div className="mv-card mission-card">

            <div className="mv-icon">
              <FaBullseye />
            </div>

            <h3>Our Mission</h3>

            <p>
              To empower businesses through innovative software development,
              strategic IT consulting, and intelligent digital solutions that
              improve operational efficiency, accelerate digital
              transformation, and create sustainable business growth.
            </p>

            <ul>
              <li>Deliver innovative software solutions</li>
              <li>Build long-term client partnerships</li>
              <li>Maintain quality and transparency</li>
              <li>Drive digital transformation</li>
            </ul>

          </div>

          {/* Vision */}

          <div className="mv-card vision-card">

            <div className="mv-icon">
              <FaEye />
            </div>

            <h3>Our Vision</h3>

            <p>
              To become a globally trusted technology company recognized for
              engineering excellence, innovation, customer success, and
              delivering future-ready digital solutions that positively impact
              businesses and society.
            </p>

            <ul>
              <li>Lead through innovation</li>
              <li>Adopt emerging technologies</li>
              <li>Create global business value</li>
              <li>Inspire continuous innovation</li>
            </ul>

          </div>

        </div>

      </div>

    </section>
  );
};

export default MissionVision;